export default __webpack_public_path__ + "static/media/037-crib.c093610a.png";